var map = {
	"./aave-markets.json": 59467,
	"./balancer-markets.json": 20978,
	"./compound-markets.json": 99887,
	"./curve-markets.json": 47384,
	"./dodo-markets.json": 14366,
	"./frax-markets.json": 59901,
	"./instadapp-markets.json": 86391,
	"./lido-markets.json": 79618,
	"./yearn-markets.json": 10207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92179;